<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="text-cyan-500" xmlns="http://www.w3.org/2000/svg">
  <circle cx="12" cy="12" r="8" fill="currentColor" stroke="white" />
  <path d="M15 10L11 14L9 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>

<script>
export default {
  
}
</script>

<style>

</style>